import { createContext, FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { IChangeEmailContextProviderProps as IProps } from './types';

const changeEmailContext = createContext<{
  step: number;
  newEmail: string;
  nextStep: () => void;
  prevStep: () => void;
  setNewEmail: (email: string) => void;
}>({
  step: 0,
  newEmail: '',
  nextStep: () => {},
  prevStep: () => {},
  setNewEmail: () => {},
});

export const useChangeEmailContext = () => useContext(changeEmailContext);

export const ChangeEmailContextProvider: FC<IProps> = ({ children, isModalOpened }) => {
  const [changeEmailContextState, setChangeEmailContextState] = useState<{
    step: number;
    newEmail: string;
  }>({
    step: 0,
    newEmail: '',
  });

  const nextStep = useCallback((): void => {
    setChangeEmailContextState((prev) => ({
      ...prev,
      step: prev.step + 1,
    }));
  }, []);

  const prevStep = useCallback((): void => {
    setChangeEmailContextState((prev) => ({
      ...prev,
      step: prev.step - 1,
    }));
  }, []);

  const setNewEmail = useCallback((email: string): void => {
    setChangeEmailContextState((prev) => ({
      ...prev,
      newEmail: email,
    }));
  }, []);

  useEffect(() => {
    if(isModalOpened) {
      setChangeEmailContextState((prev) => ({
        ...prev,
        step: 0,
        newEmail: '',
      }));
    }
  }, [isModalOpened]);

  return (
    <changeEmailContext.Provider
      value={useMemo(
        () => ({ ...changeEmailContextState, nextStep, prevStep, setNewEmail }),
        [changeEmailContextState, nextStep, prevStep, setNewEmail],
      )}
    >
      {children}
    </changeEmailContext.Provider>
  );
};
